<template>
    <div class="HolidayManagement">
        <el-input v-model="Parmars.year" placeholder="请输入年份" style="width: 300px;"></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="list(0)">查询</el-button>
        <el-button type="primary" @click="AddHolidayManagement=true">新增</el-button>
        <el-table
            :data="YearData.Lists"
            :cell-style="{'text-align':'center'}"
            style="width: 100%;margin: 10px 0;">
            <el-table-column
                type="index"
                width="100px"
                label="序号">
            </el-table-column>
            <el-table-column
                prop="year"
                label="年份"
               >
            </el-table-column>
            <el-table-column
                prop="holiday"
                label="日期"
                sortable
                >
            </el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <span class="delete_btn btn" @click="Deleteholiday(scope.row)">删除</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="Parmars.pageIndex"
            hide-on-single-page
            :page-size="Parmars.pageSize"
            layout="prev, pager, next, jumper"
            :total="YearData.Counts">
        </el-pagination>

        <el-drawer
        title="新增假期"
        :visible.sync="AddHolidayManagement"
        width="30%"
        >
        <el-date-picker
        class="datapicker"
        v-model="Holidayval"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期">
        </el-date-picker>
        <div class="dialog-footer">
            <el-button @click="AddHolidayManagement = false" >取 消</el-button>
            <el-button type="primary" @click="AddHolidays" :loading="iscontinuous">确 定</el-button>
        </div>
        </el-drawer>

    </div>
</template>
<script>
export default{
    name:'HolidayManagement',
    data() {
        return {
            iscontinuous:false,
            Parmars:{
                year:new Date().getFullYear(),
                pageSize:10,
                pageIndex:1
            },
            Holidayval:'',
            YearData:'',
            // 弹窗
            AddHolidayManagement:false
        }
    },
    mounted() {
        this.list();
    },
    methods: {
        list(e){
            if(e==0){
                this.Parmars.pageIndex=1;
            }
            this.$Http_Post('Holidays/GetHolidayList',this.Parmars).then(res=>{
                if(res.Code==0){
                    this.total=res.Counts;
                    this.YearData=res.Data;
                }
            })
        },
        // 分页
        handleCurrentChange(e){
            this.Parmars.pageIndex=e;
            this.list();
        },

        // 新增
        AddHolidays(){
            this.iscontinuous = true
            this.$Http_Post('Holidays/AddHolidays',{year:this.Holidayval.slice(0,4),holiday:this.Holidayval}).then(res=>{
                if(res.Code==0){
                    this.iscontinuous = false
                    this.list();
                    this.$message({message:res.Message,type: 'success'});
                }else{
                    this.iscontinuous = false
                    this.$message({message:res.Message,type: 'error'});
                }
                this.AddHolidayManagement=false;
            });
            
        },

        // 删除
        Deleteholiday(e){
            this.$Http_Post('Holidays/DelHolidays',{holidayskeys:[e.holidayskey]}).then(res=>{
                if(res.Code==0){
                    this.list();
                    this.$message({message:res.Message,type: 'success'});
                }else{
                    this.$message({message:res.Message,type: 'error'});
                }
            });
        },
        
        
    },
}
</script>
<style scoped>
.HolidayManagement{background: #fff;padding: 30px;}
.btn{color: #409EFF;cursor: pointer;padding:0 5px;}
.dialog-footer{margin: 20px 20px;text-align: right;}
.datapicker{margin:0 30px;}
</style>